import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'

export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    uid: 0,
    accesstoken: ''
  }

  async componentWillMount() {
    await setUidToken(this.props.location.query)
    let { uid, accesstoken } = localstorage.get('userInfo')
    this.setState({
      uid: uid,
      accesstoken: accesstoken
    })
  }

  componentDidMount() {
    setDocumentTitle('How to delete your user information')
  }

  render() {
    return (
      <div className="policy">
        <h1>How to delete your user information</h1>
        <br />
        If you need to delete your user information, please login to your app and send feedback to us at the following path: Me > Feedback<br/>
        or do it by youself on this path: <b>me > setting > delete account</b>
        <br/>
        If you are unable to log in to your app, please contact us: dilidili2046@gmail.com
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/deleteapp_voca/index.js